import api from '@/utils/api';

/**
 * Get all dealer's suppliers (uses logged in user's company_id)
 * @returns {Promise}
 */
const getDealerSuppliersApi = () => {
  const url = `dealer/supplier`;
  return api.get(url);
};

export default getDealerSuppliersApi;
